import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import * as StyledImages from './images.styles';
import sleep from '../../../helpers/sleep';
import { withCropOptions } from '../../../helpers/images/withCropOptions';

const Images = ({
	images
}) => {
	const [isAnimating, setIsAnimating] = useState(false);
	const [animationDirection, setAnimationDirection] = useState('left');
	const [currentIndex, setIndex] = useState(0);

	const setImage = async (index) => {
		setIsAnimating(true);
		await sleep(190);
		setIndex(index);
		await sleep(310);
		setIsAnimating(false);
	};

	const onDotClick = (index, e) => {
		e.preventDefault();
		if(isAnimating) return;
		setImage(index);
	};

	const onChevronClick = (index, direction, e) => {
		e.preventDefault();
		if(isAnimating) return;
		setAnimationDirection(direction);
		if(index < 0) index = (images.length - 1);
		else if((index + 1) > images.length) index = 0;
		setImage(index);
	};

	const currentImg = images[currentIndex] || '';

	return (
		<StyledImages.Wrapper
			image={withCropOptions(currentImg)}
			mobileWidth="800"
			tabletWidth="800"
			desktopWidth="800"
			desktopHugeWidth="800"
			retinaWidth="800">
			<StyledImages.Animation active={isAnimating} direction={animationDirection} />
			<StyledImages.CarouselLeft onClick={onChevronClick.bind(this, (currentIndex - 1), 'left')}>
				<FaChevronLeft />
			</StyledImages.CarouselLeft>
			<StyledImages.CarouselRight onClick={onChevronClick.bind(this, (currentIndex + 1), 'right')}>
				<FaChevronRight />
			</StyledImages.CarouselRight>
			<StyledImages.Dots>
				{images.map((image, index) => (
					<StyledImages.Dot
						key={index}
						onClick={onDotClick.bind(this, index)}
						active={currentIndex === index} />
				))}
			</StyledImages.Dots>
		</StyledImages.Wrapper>
	);
};

Images.propTypes = {
	images: PropTypes.array
};

Images.defaultProps = {
	images: ['/media/3905/ibud-banner.png?width={width}&height={height}&mode=crop']
};

export default Images;
